import styled from 'styled-components'

export const BackBarContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100vw;
  height: 48px;
  background: #fff;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 3;
  padding: 0 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
`

export const BackIconContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;

  img {
    width: 16px;
    height: 16px;
  }
`
